//Tipos de mensagem de socket de contatos
const OUTPUT_TIPO = {
  RP: { id: "RP", descricao: "Relatório" },
  CN: { id: "CN", descricao: "Consulta" },
  AN: { id: "AN", descricao: "Análise" },
  DD: { id: "DD", descricao: "Dados" },
};

export default OUTPUT_TIPO;
